var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-list",
    { staticClass: "q-mb-md" },
    [
      _c(
        "q-collapsible",
        {
          attrs: { icon: "fas fa-filter", label: _vm.getNameFilter },
          on: { click: _vm.toggle },
          model: {
            value: _vm.open,
            callback: function($$v) {
              _vm.open = $$v
            },
            expression: "open"
          }
        },
        [
          _vm.options
            ? _c("div", { staticClass: "row gutter-sm" }, [
                _vm.options.areas
                  ? _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12" },
                      [
                        _c("select-multiple", {
                          attrs: {
                            label: "areas",
                            filters: _vm.filters.area,
                            options: _vm.options.areas
                          },
                          on: {
                            on_value: function($event) {
                              _vm.filters.area = $event
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.options.profiles
                  ? _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12" },
                      [
                        _c("q-select", {
                          attrs: {
                            chips: "",
                            options: _vm.options.profiles,
                            multiple: "",
                            "float-label": _vm.$t("profiles"),
                            clearable: ""
                          },
                          model: {
                            value: _vm.filters.profile,
                            callback: function($$v) {
                              _vm.$set(_vm.filters, "profile", $$v)
                            },
                            expression: "filters.profile"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.options.library_file_categories
                  ? _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12" },
                      [
                        _c("q-select", {
                          attrs: {
                            chips: "",
                            multiple: "",
                            options: _vm.options.library_file_categories,
                            "float-label": _vm.$t("categories"),
                            clearable: ""
                          },
                          model: {
                            value: _vm.filters.category,
                            callback: function($$v) {
                              _vm.$set(_vm.filters, "category", $$v)
                            },
                            expression: "filters.category"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.options.library_file_extensions
                  ? _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12" },
                      [
                        _c("q-select", {
                          attrs: {
                            chips: "",
                            multiple: "",
                            options: _vm.options.library_file_extensions,
                            "float-label": _vm.$t("extension"),
                            clearable: ""
                          },
                          model: {
                            value: _vm.filters.extension,
                            callback: function($$v) {
                              _vm.$set(_vm.filters, "extension", $$v)
                            },
                            expression: "filters.extension"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.options.statuses
                  ? _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12" },
                      [
                        _c("q-select", {
                          attrs: {
                            chips: "",
                            multiple: "",
                            options: _vm.options.statuses,
                            "float-label": _vm.$t("status"),
                            clearable: ""
                          },
                          model: {
                            value: _vm.filters.status,
                            callback: function($$v) {
                              _vm.$set(_vm.filters, "status", $$v)
                            },
                            expression: "filters.status"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6 gutter" },
                  [
                    _c("q-datetime", {
                      attrs: {
                        "float-label": _vm.$t("creation_date_from"),
                        type: "datetime",
                        format: "DD/MM/YYYY HH:mm",
                        clearable: ""
                      },
                      model: {
                        value: _vm.filters.start_date_display,
                        callback: function($$v) {
                          _vm.$set(_vm.filters, "start_date_display", $$v)
                        },
                        expression: "filters.start_date_display"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6 gutter" },
                  [
                    _c("q-datetime", {
                      attrs: {
                        "float-label": _vm.$t("creation_date_to"),
                        type: "datetime",
                        format: "DD/MM/YYYY HH:mm",
                        clearable: ""
                      },
                      model: {
                        value: _vm.filters.end_date_display,
                        callback: function($$v) {
                          _vm.$set(_vm.filters, "end_date_display", $$v)
                        },
                        expression: "filters.end_date_display"
                      }
                    })
                  ],
                  1
                )
              ])
            : _vm._e(),
          _c("div", { staticClass: "row gutter-sm justify-end q-mt-sm" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-3" },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "negative",
                    label: _vm.$t("clear_filters"),
                    icon: "fas fa-eraser"
                  },
                  on: {
                    click: function($event) {
                      return _vm.clearFilter()
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-3" },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "secondary",
                    label: _vm.$t("apply_filter_plural"),
                    icon: "fas fa-filter"
                  },
                  on: {
                    click: function($event) {
                      return _vm.requestFiltered()
                    }
                  }
                })
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }